import { v4 as uuid } from 'uuid';

export const makeUuid = () => uuid();
export const getPasscodeFromUuid = (uuid: string) => {
  let hash = 0;

  for (let i = 0; i < uuid.length; i++) {
    hash = (hash << 5) - hash + uuid.charCodeAt(i);
    hash = hash | 0;
  }

  hash = Math.abs(hash);

  const password = String(hash).slice(-4).padStart(4, '0');

  return password;
};
